import axios from 'axios';
import { localStorageGetItem } from './storage-available';
// config
import { APP_HOST_API_KEY, HOST_API_TOKEN } from '../config-global';

// ----------------------------------------------------------------------

export const axiosInstance = axios.create({
  baseURL: APP_HOST_API_KEY,
  headers: {
    Authorization: `Bearer ${HOST_API_TOKEN}`,
  },
});

axiosInstance.interceptors.request.use((config) => {
  // use config.params if it has been set
  const acceptedLangs = ['en', 'pt'];

  let lng = localStorageGetItem('i18nextLng');

  // fall back to 'pt' when the stored language is missing or not supported
  if (!acceptedLangs.includes(lng)) {
    lng = 'pt';
    localStorage.setItem('i18nextLng', 'pt');
  }

  config.params = config.params || {};
  // add any client instance specific params to config
  config.params['locale'] = lng;
  return config;
});
